import styled, { css } from 'styled-components'

import { Colors } from 'common-constants/colors'

const iconItemCss = css`
  width: 14px;
  height: 14px;
  display: inline-flex;
  vertical-align: text-top;
  border-radius: 50%;
  flex-shrink: 0;
  align-items: center;
  margin: 0 2px;

  svg {
    display: inline-block;
  }
`

export const Verified = styled.span`
  ${iconItemCss};
`

export const Online = styled.span`
  ${iconItemCss};
  ${({ theme }) => theme.marginRight}: 5px;

  background-color: ${Colors.iconBackgroundColorAquamarine};
`

export const Mute = styled.span`
  ${iconItemCss};
`

export const OnlineMain = styled.span`
  ${iconItemCss};
  background: ${Colors.iconBackgroundColorAquamarine}
    linear-gradient(
      89.94deg,
      ${Colors.iconBackgroundStartOnline} 4.59%,
      ${Colors.iconBackgroundColorAquamarine} 95.41%
    );
`
